import { Selector } from "@ngxs/store";
import { ReturnPath, SettingState, SettingStateModel } from "./setting.state";
import { RecordTagSet, RecordTitleSet } from "@app/models/record.model";
import { ScheduleTitle } from "@app/models/schedule.model";
import { RouteCondition } from "@app/shared/enum/route";

export class SettingSelectors {
    @Selector([SettingState])
    static aliasId(state: SettingStateModel): string {
        return state.aliasId;
    }

    @Selector([SettingState])
    static primaryPath(state: ReturnPath): string[] {
        const { paths } = state;
        if (!paths) {
            return sessionStorage.getItem('schedule-insert-origin')?.split('/') || [];
        }
        return state.paths;
    }

    @Selector([SettingState])
    static primaryPathAction(state: ReturnPath): Function | undefined {
        if (state.navigateFinally) {
            return state.navigateFinally();
        }
        return undefined;

    }

    @Selector([SettingState])
    static isWebView(state: SettingStateModel): boolean {
        return state.isWebview;
    }

    @Selector([SettingState])
    static titleSetList(state: SettingStateModel): RecordTitleSet[] {
        return state.titleSetList;
    }

    @Selector([SettingState])
    static scheduleTitleList(state: SettingStateModel): ScheduleTitle[] {
        return state.scheduleTitleList;
    }

    @Selector([SettingState])
    static selectedTitle(state: SettingStateModel) {
        return state.selectedTitle;
    }

    @Selector([SettingState])
    static selectedTitles(state: SettingStateModel) {
        return state.selectedTitles;
    }

    @Selector([SettingState])
    static menuList(state: SettingStateModel) {
        return state.menuList;
    }

    @Selector([SettingState])
    static buttonTitleList(state: SettingStateModel) {
        return state.buttonTitleList.filter((item) => item.readable && !!item.nm);
    }

    @Selector([SettingState])
    static titleTagList(state: SettingStateModel): RecordTagSet[] {
        return state.titleTagList;
    }

    @Selector([SettingState])
    static routeCondition(state: SettingStateModel): RouteCondition {
        return state.routeCondition;
    }

    @Selector([SettingState])
    static isCareConneFeature(state: SettingStateModel): boolean {
        return state.isCareConneOffice && state.careconnetPass != -1;
    }

    @Selector([SettingState])
    static CareConnePass(state: SettingStateModel): number {
        return state.careconnetPass;
    }
}